import { FormErrorMessage, Text } from '@ksyos/design-system';
import { translateKey } from '../../../../../translate';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

interface IScoreProps {
    error?: string;
    handleChange: (value: number) => void;
    question: string;
    value: number | null;
}

export function ScoreInput(props: IScoreProps) {
    const scoreButtons = [];

    for (let i = 0; i <= 10; i++) {
        const isScoreSelected = props.value === i;
        scoreButtons.push(
            // TODO: Handle the accessibility issues
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            <div
                onClick={() => props.handleChange(i)}
                style={{
                    background: isScoreSelected
                        ? 'linear-gradient(-225deg, rgb(207, 0, 177) 0%, rgb(255, 55, 240) 100%)'
                        : '#ffffff',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    display: 'flex',
                    height: '40px',
                    width: '8%',
                }}
            >
                <p
                    style={{
                        color: isScoreSelected ? '#ffffff' : undefined,
                        fontWeight: isScoreSelected ? 'bold' : undefined,
                        margin: 'auto',
                    }}
                >
                    {i}
                </p>
            </div>
        );
    }

    return (
        <Stack>
            <StyledFormGroup
                hasErrors={!!props.error}
                label={props.question}
                layout="vertical"
            >
                <div
                    className="d-flex justify-content-between"
                    style={{ marginTop: '16px' }}
                >
                    {scoreButtons}
                </div>
                {!!props.error && <FormErrorMessage>{translateKey(`validation.${props.error}`)}</FormErrorMessage>}
                <div
                    className="d-flex justify-content-between gap-8"
                    style={{ marginTop: '11px' }}
                >
                    <Text>Nee, helemaal niet</Text>
                    <hr
                        className="flex-grow-1"
                        style={{
                            border: 0,
                            borderTop: '1px solid',
                            color: '#322A24',
                            height: '1px',
                            margin: '8px',
                            marginTop: '12px',
                        }}
                    />
                    <Text>Ja, helemaal</Text>
                </div>
            </StyledFormGroup>
        </Stack>
    );
}
